import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import style from './style.module.scss';
import { WidgetIcon } from '@interfaces/widget.interface';
import { WidgetIconEnum } from '@utils/constants';

interface WidgetIconContainerProps {
    icon: WidgetIcon | null | undefined;
    isWidgetForm?: boolean;
}

const iconMap: { [key in WidgetIcon]: IconProp } = {
    [WidgetIconEnum.Visit]: ['fad', 'house-medical-flag'],
    [WidgetIconEnum.VisitExclamation]: ['fad', 'house-medical-circle-exclamation'],
    [WidgetIconEnum.VisitCross]: ['fad', 'house-medical-circle-xmark'],
    [WidgetIconEnum.VisitCheck]: ['fad', 'house-medical-circle-check'],
    [WidgetIconEnum.Subject]: ['fas', 'user'],
    [WidgetIconEnum.SubjectTime]: ['fad', 'user-clock'],
    [WidgetIconEnum.SubjectCheck]: ['fad', 'user-check'],
    [WidgetIconEnum.SubjectCross]: ['fad', 'user-xmark'],
    [WidgetIconEnum.SubjectSlash]: ['fad', 'user-slash'],
    [WidgetIconEnum.SubjectOptions]: ['fad', 'user-cog'],
    [WidgetIconEnum.Patient]: ['fas', 'user-injured'],
    [WidgetIconEnum.SubjectGroup]: ['fas', 'users'],
    [WidgetIconEnum.SubjectGroupSlash]: ['fad', 'users-slash'],
    [WidgetIconEnum.SubjectGroupOptions]: ['fad', 'users-cog'],
    [WidgetIconEnum.Site]: ['fas', 'hospital'],
    [WidgetIconEnum.Assessment]: ['fas', 'file'],
    [WidgetIconEnum.AssessmentCheck]: ['fad', 'file-circle-check'],
    [WidgetIconEnum.AssessmentMissing]: ['fad', 'file-circle-question'],
    [WidgetIconEnum.AssessmentExclamation]: ['fad', 'file-circle-exclamation'],
    [WidgetIconEnum.AdverseEvent]: ['fas', 'bed-pulse'],
    [WidgetIconEnum.Heart]: ['fas', 'heart'],
    [WidgetIconEnum.HeartCross]: ['fad', 'heart-circle-xmark'],
    [WidgetIconEnum.HeartCheck]: ['fad', 'heart-circle-check'],
    [WidgetIconEnum.HeartExclamation]: ['fad', 'heart-circle-exclamation'],
    [WidgetIconEnum.Clock]: ['fas', 'clock'],
    [WidgetIconEnum.Calendar]: ['fas', 'calendar-days'],
    [WidgetIconEnum.Hourglass]: ['fas', 'hourglass'],
    [WidgetIconEnum.Ambulance]: ['fas', 'truck-medical'],
    [WidgetIconEnum.Observation]: ['fas', 'eye'],
    [WidgetIconEnum.Syringe]: ['fas', 'syringe'],
    [WidgetIconEnum.Random]: ['fas', 'dice'],
    [WidgetIconEnum.Stethoscope]: ['fas', 'stethoscope'],
};

const WidgetIconContainer = ({ icon, isWidgetForm }: WidgetIconContainerProps) => {
    const fontAwesomeIcon = icon && iconMap[icon];

    return (
        <div className={cn(style.widgetContainer, isWidgetForm && style.widgetFormIcon)}>
            {fontAwesomeIcon && (
                <FontAwesomeIcon
                    icon={fontAwesomeIcon}
                    className={cn(style.frontIcon)}
                    style={!isWidgetForm ? { width: '37px', height: '32px' } : undefined}
                />
            )}
        </div>
    );
};

export default WidgetIconContainer;
